import { createContext, useContext, useMemo, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "ru";
    return localStorage.getItem("mnvr_lang") || "ru";
  });

  const setLang = useCallback((code) => {
    setLangState(code);
    try {
      localStorage.setItem("mnvr_lang", code);
    } catch (e) {
      /* ignore */
    }
  }, []);

  const value = useMemo(
    () => ({ lang, setLang, t: translations[lang] || translations.ru }),
    [lang, setLang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
